import axios from "axios";
import { UserSession } from "../user_session";
import * as Vars from "./Vars";

export class Columns {

  /**
   * Loads all the columns, where are located in a certain container.
   * @param {number} id The container ID, where the columns are stored.
   */
  static async load(id) {
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/column/",
        method: "GET",
        params: {
          _console_token: UserSession.token,
          container: id
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  /**
   * Creates a new column inside of the container.
   * @param {number} container The container ID, where the new column should be created.
   * @param {string} column_name The new name of the column.
   */
  static async add(container, column_name){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/column/",
        method: "POST",
        data: {
          _console_token: UserSession.token,
          container: container,
          name: column_name
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  /**
   * Edits an existing column.
   * @param {number} column_id The column ID, which should be updated.
   * @param {string} column_name The new column name.
   * @param {string} column_pattern The pattern, which should match the data inside of the container.
   * @param {boolean} column_required Defines if the column should be required to be filled.
   */
  static async edit(column_id, column_name, column_pattern, column_required){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/column/",
        method: "PUT",
        data: {
          _console_token: UserSession.token,
          id: column_id,
          name: column_name,
          pattern: btoa(column_pattern == null ? "/(.*)/" : column_pattern.replace(/\\/g, "\\\\")),
          required: column_required
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  /**
   * Deletes a column.
   * @param {number} column_id The column ID, which should be deleted.
   */
  static async delete(column_id){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/column/",
        method: "DELETE",
        data: {
          _console_token: UserSession.token,
          id: column_id
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }
}
